module.exports = __webpack_public_path__ + "static-prod-1/img/m_logo.a072acf3.png";